import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export type GrowthBrief = {
  id: string;
  created_at: string;
  week_of: string;
  status: 'draft' | 'approved' | 'sent';
  content_md: string;
  evidence: { claim: string; urls: string[] }[];
};

async function fetchBriefs(): Promise<GrowthBrief[]> {
  const { data, error } = await supabase
    .from('growth_briefs')
    .select('*')
    .order('week_of', { ascending: false })
    .limit(20);
  if (error) throw error;
  return (data ?? []) as GrowthBrief[];
}

export function useGrowthBriefs() {
  return useQuery({
    queryKey: ['growth', 'briefs'],
    queryFn: fetchBriefs,
  });
}

export function useGrowthBriefUpdate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      updates,
    }: {
      id: string;
      updates: Partial<Pick<GrowthBrief, 'status' | 'content_md'>>;
    }) => {
      const { data, error } = await supabase
        .from('growth_briefs')
        .update(updates)
        .eq('id', id)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['growth', 'briefs'] }),
  });
}
